import { _js } from '@ifixit/utils/localize';
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const LinkButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('link'),
      isDisabled: !editor.can().editLink(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().editLink().run()}
         isDisabled={state.isDisabled}
         isActive={state.isActive}
         icon={<FontAwesomeIcon icon={faLink} />}
         title={_js('Insert a link')}
         shortcut={'k'}
      />
   );
};
